import { mean, round } from 'lodash'

export const calculateAverageRating = (scores: Array<number | undefined | null>) => {
  const filteredZeros = scores.filter((score) => score !== 0)
  const rounded = round(mean(filteredZeros))

  return rounded || null
}
